import { addOnCheckboxActionHandler } from './cartActionHandler';
import { PAGE, LAYOUT_TYPE } from './domain';
import { variantSelectionHandler } from './variantSelectionHandler';
import createSlider from './slider';
import renderPlaceholder from './render/components/renderPlaceholder';
import { getForm, getSubmitButton, removeUpsell } from './render/common/utils';
import CssClasses from './template/common/cssClasses';
import buildaddOnsHtml from './render/build/buildAddonsHtml';
import { getAppProps } from './utils';
import { setPopupsLoaded } from './template/components/popUp/common';

export default function initRenderer(addOns, popups, page) {
  const { options } = getAppProps();

  const cartForm = getForm(page, options);
  if (!cartForm) {
    removeUpsell();
    return;
  }

  const addToCartButton = getSubmitButton(options, cartForm, page);
  const isAriaDisabled =
    addToCartButton &&
    addToCartButton.getAttribute('aria-disabled') &&
    addToCartButton.getAttribute('aria-disabled') === 'true';
  if (
    !addToCartButton ||
    ((addToCartButton.disabled || isAriaDisabled) &&
      !options.displayOnDisabledCartButton)
  ) {
    removeUpsell();
  } else {
    if (
      page === PAGE.Product &&
      (options.addOnType === 'checkbox' ||
        options.addOnType === 'dropdown' ||
        options.quantitySelect)
    ) {
      addOnCheckboxActionHandler(cartForm, addToCartButton, options);
    }
    if (options.groupVariants) {
      variantSelectionHandler(options);
    }
    const hasSlider =
      (page === PAGE.Product && options.productLayout === LAYOUT_TYPE.Slider) ||
      (page === PAGE.Cart && options.cartLayout === LAYOUT_TYPE.Slider);
    buildaddOnsHtml(addToCartButton, addOns, popups, page, function(
      addOnsHtml
    ) {
      setPopupsLoaded(true);
      const addOnContainer = document.querySelector(
        `.${CssClasses.addOnContainer}`
      );
      if (addOnContainer) {
        addOnContainer.innerHTML = '';
        if (hasSlider) {
          addOnContainer.className = `${addOnContainer.className} ${CssClasses.invisible}`;
        }
        addOnContainer.insertAdjacentHTML('afterbegin', addOnsHtml);
        if (hasSlider) {
          createSlider(function() {
            new Flickity(addOnContainer, {
              pageDots: false,
              contain: true,
              freeScroll: true,
              cellAlign: 'left'
            });
            addOnContainer.className = addOnContainer.className.replace(
              CssClasses.invisible,
              ''
            );
          });
        }
      }
    });
  }
}

export { renderPlaceholder, removeUpsell };
